var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { forwardRef } from 'react';
import * as TabsPrimitive from '@radix-ui/react-tabs';
import { cn } from 'root/src/client/v2/common/helpers/cn';
// Radix Tabs ported with redesign tokens (active trigger = brand gradient). `@radix-ui/react-tabs`
// is already a dependency, so we reuse it instead of hand-rolling tab state.
export const Tabs = TabsPrimitive.Root;
export const TabsList = forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (<TabsPrimitive.List ref={ref} className={cn('inline-flex items-center justify-center gap-1 rounded-xl border border-solid border-white/[0.06] bg-white/[0.03] p-1 text-muted-foreground', className)} {...props}/>);
});
TabsList.displayName = TabsPrimitive.List.displayName;
export const TabsTrigger = forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (<TabsPrimitive.Trigger ref={ref} className={cn('inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-lg px-3 py-1.5 text-sm font-medium transition-all', 'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40 disabled:pointer-events-none disabled:opacity-50', 'data-[state=active]:bg-gradient-brand data-[state=active]:text-white data-[state=inactive]:hover:text-foreground', className)} {...props}/>);
});
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName;
export const TabsContent = forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (<TabsPrimitive.Content ref={ref} className={cn('mt-3 focus-visible:outline-none', className)} {...props}/>);
});
TabsContent.displayName = TabsPrimitive.Content.displayName;
